import * as React from 'react'
import * as TogglePrimitive from '@radix-ui/react-toggle'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@util/tailwindcss'

const toggleVariants = cva(
  'inline-flex items-center justify-center rounded-md text-[12px] font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-offWhite data-[state=on]:border-offWhite data-[state=on]:text-gray-900',
  {
    variants: {
      variant: {
        default: 'bg-gray-500 text-offWhite hover:bg-gray-600',
        outline: 'border border-offWhite text-offWhite bg-transparent hover:bg-offWhite hover:text-gray-900',
      },
      size: {
        default: 'h-10 px-3',
        sm: 'h-9 px-2.5 rounded-[1rem]',
        lg: 'h-11 px-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>
>(({ children, className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root ref={ref} className={cn(toggleVariants({ variant, size, className }))} {...props}>
    {typeof children === 'string' ? <span className="mt-[2px]">{children}</span> : children}
  </TogglePrimitive.Root>
))

Toggle.displayName = TogglePrimitive.Root.displayName

export { Toggle, toggleVariants }
